import React, { useEffect, useState } from "react";
import { notification } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../../../controllers/V1/cms/bannerDataController";

import ImageUploader from "../../../../components/ImageUploader/ImgUploader";
import { ASSETS_BASE_URL } from "../../../../config/constants";

const BannerAddEditData = () => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [showUploader, setShowUploader] = useState(false);
  const toggleImgUploader = () => setShowUploader(!showUploader);
  const [imageUrl, setImageUrl] = useState(state?.image || "");

  // const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    setAddEditData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);

      const params = {
        ...(form.get("edit_id") && { editId: form.get("edit_id") }),
        page: form.get("page"),
        show_on: form.get("show_on"),
        seq_order : form.get("seq_order") || 1,
        image: imageUrl || "",
      };
      const isValidate = await validateFormData(params);
      if (isValidate === true) {
        const res = await addEditData(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/banner/list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        // console.log('validation error',error);
        notification.open({
          message: "Oops!",
          description: `Validation Error.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const { page, show_on, image } = formData;

      let status = false;
      let msg = "noError";
      let error_field = "noError";

      if (!page) {
        error_field = "page";
        msg = "Page is required.";
        status = false;
      } else if (!show_on) {
        error_field = "show_on";
        msg = "show on is required.";
        status = false;
      } else if (!image) {
        error_field = "image";
        msg = "Image is required.";
        status = false;
      } else {
        status = true;
      }

      if (!status && setError) {
        setError((prevError) => ({
          ...prevError,
          [error_field]: msg,
        }));
      }

      return status;
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };

  useEffect(() => {
    document.title = `Orbit Kuwait || ${
      ADDEDITDATA?._id ? "Edit" : "Add"
    } Banner`;
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading">
              {" "}
              {ADDEDITDATA?._id ? `Edit` : `Add`} Banner{" "}
            </h5>
          </React.Fragment>
          <Link to={"/cms/banner/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <ArrowLeftOutlined /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form
                method="post"
                className="inventory_form_main_contnet"
                onSubmit={handleSubmit}
              >
                <input
                  type="hidden"
                  name="edit_id"
                  id="edit_id"
                  value={ADDEDITDATA._id || ""}
                />

                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span> Page:
                    </label>

                    <select
                      title="Page"
                      placeholder="Page"
                      type="text"
                      name="page"
                      className="form-control store_input_field"
                      id="page"
                      value={ADDEDITDATA?.page}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="Home">Home</option>
                      <option value="Lotto">Lotto</option>
                    </select>
                    {error.page && <p style={{ color: "red" }}>{error.page}</p>}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="show_on"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Show On:
                    </label>
                    <select
                      title="Show On"
                      name="show_on"
                      className="form-control store_input_field"
                      id="show_on"
                      value={ADDEDITDATA?.show_on} // Adjust this based on the state key for "Show On"
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="POS">POS</option>
                      <option value="Web">Web</option>
                      <option value="App">App</option>
                    </select>
                    {error.show_on && (
                      <p style={{ color: "red" }}>{error.show_on}</p>
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="show_on"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Seq. Order:
                    </label>
                    <input
                      type="number"
                      title="Seq. Order"
                      name="seq_order"
                      className="form-control store_input_field"
                      id="seq_order"
                      value={ADDEDITDATA?.seq_order} 
                      onChange={handleChange}
                    />
                      
                    {error.show_on && (
                      <p style={{ color: "red" }}>{error.show_on}</p>
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="image"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Image :
                    </label>
                    <input
                      type="hidden"
                      value={imageUrl}
                      name="image"
                      id="image"
                    />
                    <button
                      type="button"
                      className="form-control store_input_field btn btn-primary inventory_save_button"
                      onClick={toggleImgUploader}
                    >
                      Select image
                    </button>
                    {imageUrl && (
                      <span>
                        <img
                          src={`${ASSETS_BASE_URL}${imageUrl}`}
                          width={"100px"}
                        />
                      </span>
                    )}
                    {error.image && (
                      <p style={{ color: "red" }}>{error.image}</p>
                    )}
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="submit"
                    className="btn btn-primary inventory_save_button"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ImageUploader
        openUpload={showUploader}
        toggleUploadOpen={toggleImgUploader}
        setImgUrl={setImageUrl}
      />
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default BannerAddEditData;
